module.exports = __webpack_public_path__ + "static/media/img-floor-3.534847f8.png";